export default "__VITE_ASSET__BEw0aIYR__"